<div class="chip-list ds-input"
     #elementBody
     (click)="itemInput.focus()">
  <div class="chip-list__chip-grid">
    <div class="chip-list__chip-row"
         [class.dark]="isDark"
         *ngFor="let item of listForm.controls; let i = index">
      <span>{{ item.get('name').value }}</span>
      <img src="./assets/images/icons/close-error-icon.svg"
           *ngIf="showClose"
           (click)="remove(i)">
    </div>
    <input
      class="chip-input"
      [placeholder]="listForm?.controls?.length ? '' : placeholder"
      (focus)="showDropdown = true"
      [formControl]="inputFormControl"
      (keydown.backspace)="onBackspace(itemInput.value)"
      #itemInput
      (blur)="itemInput.value && onFocusOut({name:itemInput.value})"
      (keydown.enter)="add({name:itemInput.value})"/>
    <div *ngIf="withCheckboxes && showDropdown && checkboxOptions?.length"
         #toggle class="autocomplete checkbox-list">
      <div *ngFor="let item of checkboxOptions" class="autocomplete__item">
        <input type="checkbox"
               #it
               (click)="itemInput.focus(); checkboxValueChange(item, !it.checked)"
               [checked]="checkSelectedOptions(item.name)"
               [id]="item.id"
               class="ds-checkbox">
        <label [for]="item.id" class="ds-checkbox-label black">
          {{item.name}}
        </label>
      </div>
    </div>
  </div>
  <div *ngIf="filteredItems.length > 0 && showDropdown"
       (click)="$event.stopPropagation()"
       #toggle class="autocomplete">
    <div *ngFor="let item of filteredItems" class="autocomplete__item"
         (click)="$event.stopPropagation(); add(item)">
      {{ item.name }}
    </div>
  </div>
</div>
